/* eslint-ignore */
// @ts-ignore
// @ts-nocheck

/**
 *
 *
 * @export
 * @param {*} step
 * @returns
 */
export function toggleStep(step) {
  return {
    type: 'TOGGLE_SIGNUP_STEP',
    step,
  };
}

/**
 *
 *
 * @export
 * @param {*} url
 * @returns
 */
export function apiHateoas(url) {
  return {
    type: 'CREATE_URL_HATEOAS',
    url,
  };
}

/**
 *
 *
 * @export
 * @param {*} document
 * @param {*} customerCode
 * @returns
 */
export function registerDocument(document, customerCode, siteId, userId) {
  return {
    type: 'REGISTER_CUSTOMER_DOCUMENT',
    document,
    customerCode,
    siteId,
    userId,
  };
}

/**
 *
 *
 * @export
 * @param {*} contactName
 * @param {*} contactId
 * @returns
 */
export function registerContactName(contactName, contactId) {
  return {
    type: 'REGISTER_CONTACT_ID',
    contactName,
    contactId,
  };
}

/**
 *
 *
 * @export
 * @param {*} lastInvoiceNumber
 * @param {*} penultimateInvoiceNumber
 * @returns
 */
export function registerLastInvoices(
  lastInvoiceNumber,
  penultimateInvoiceNumber
) {
  return {
    type: 'REGISTER_INVOICE_NUMBER',
    lastInvoiceNumber,
    penultimateInvoiceNumber,
  };
}

/**
 *
 *
 * @export
 * @param {*} token
 * @returns
 */
export function smsValidation(token) {
  return {
    type: 'REGISTER_SMS_TOKEN',
    token,
  };
}

/**
 *
 *
 * @export
 * @returns
 */
export function resetSignupState() {
  return {
    type: 'RESET_SIGNUP_STATE',
  };
}
